var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"supplier-invoiced-list",attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"persistenceKey":'supplier-invoiced-list',"gcPopupConfig":_vm.gcPopupConfig,"setLoading":_vm.setLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }